import { useContext } from 'react';
import {
  ToggleFilterVisibleStateContext,
  ToggleFilterVisibleDispatchContext,
} from './model';

export const useFilterVisibleState = () => {
  const context = useContext(ToggleFilterVisibleStateContext);
  if (context === undefined) {
    throw new Error(
      'useFilterVisibleState должен использоваться внутри FilterVisibleProvider'
    );
  }
  return context;
};

export const useFilterVisibleDispatch = () => {
  const context = useContext(ToggleFilterVisibleDispatchContext);
  if (context === undefined) {
    throw new Error(
      'useFilterVisibleDispatch должен использоваться внутри FilterVisibleProvider'
    );
  }
  return context;
};
